exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Outer___2YMUU {\n  user-select: none;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  padding-top: 4px;\n  padding-bottom: 1px;\n  display: flex;\n  align-items: flex-end;\n}\n.Outer___2YMUU:hover {\n  background-color: var(--color-background);\n}\n\n.Inner___TFCLU,\n.InnerSelected___2Qf2T {\n  width: 100%;\n  min-height: 2px;\n  background-color: var(--color-commit-did-not-render-fill);\n  color: var(--color-commit-did-not-render-fill-text);\n}\n\n.InnerSelected___2Qf2T {\n  background-color: var(--color-button-active);\n}", ""]);

// exports
exports.locals = {
	"Outer": "Outer___2YMUU",
	"Inner": "Inner___TFCLU",
	"InnerSelected": "InnerSelected___2Qf2T"
};